import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';

export type TButtonType = 'PRIMARY' | 'SECONDARY' | 'TERITIARY' | 'QUATERNARY' | 'QUINARY';

type TFontWeight = 'NORMAL' | 'BOLD' | 'SEMIBOLD';

type TExpand = 'block' | 'full' | '';

type TPopoverInfo = {
  title?: string;
  txt: string;
};

type TIconPlacement = 'BEFORE' | 'AFTER';

type TEnhancedPopoverInfo = TPopoverInfo & {
  id: string; //Note: id needs to be unique for a btn to render inline popover correctly
};

function _getFontWeight(weight: TFontWeight) {
  switch (weight) {
    case 'NORMAL':
      return 400;
    case 'SEMIBOLD':
      return 600;
    case 'BOLD':
      return 800;
  }
}
@Component({
  selector: 'ui-custom-button',
  templateUrl: './custom-button.component.html',
  styleUrls: ['./custom-button.component.scss'],
})
export class CustomButtonComponent implements OnInit {
  @Input() buttonType: TButtonType = 'PRIMARY';
  @Input() btnTxt = '';
  @Input() showProcessingBtnTxt = false;
  @Input() isDisabled = false;
  @Input() iconSrc = '';
  @Input() iconPlacement: TIconPlacement = 'BEFORE';
  @Input() iconClass: string[] = [];
  @Input() buttonWidth = '';
  @Input() buttonHeight = '';
  @Input() fontWeight: TFontWeight = 'NORMAL';
  @Input() expand: TExpand = '';
  @Input() popoverInfo?: TPopoverInfo;

  @Input() enhancedPopoverInfo?: TEnhancedPopoverInfo;

  buttonClass: string[] = [];
  buttonStyles = {};

  @Output() clickEvent = new EventEmitter();

  ngOnInit() {
    this.intializeBtnProperties();
    if (this.popoverInfo) {
      this.enhancedPopoverInfo = {
        ...this.popoverInfo,
        id: uuidv4(),
      };
    }
  }

  handleClick() {
    this.clickEvent.emit();
  }

  intializeBtnProperties() {
    //button class
    const btnType = this.buttonType.toLowerCase();
    const btnClass = this.iconSrc ? 'custom-btn-' + btnType + '-with-icon' : 'custom-btn-' + btnType;
    this.buttonClass = [btnClass];

    //button styles
    let buttonStyles = {};
    if (this.expand === 'full') buttonStyles = { ...buttonStyles, width: '100%' };
    if (this.buttonWidth) buttonStyles = { ...buttonStyles, width: this.buttonWidth };
    if (this.buttonHeight) buttonStyles = { ...buttonStyles, height: this.buttonHeight };
    if (this.fontWeight) buttonStyles = { ...buttonStyles, fontWeight: _getFontWeight(this.fontWeight) };
    this.buttonStyles = buttonStyles;
  }
}
